import { render } from "./ListEmailTemplates.vue?vue&type=template&id=6ba28c54"
import script from "./ListEmailTemplates.vue?vue&type=script&lang=js"
export * from "./ListEmailTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__